import {Address} from "./base";
import {BidBaseModel, BidderViewMode, BiddingView, BidSummaryModel, DeveloperBiddingView} from "../components/bid/bidding_model";
import {FolderView} from "../components/files/files";
import {Searchables} from "./search";
import {CompanyBase, CompanyType} from "./company";
import {CompanyPermissions} from "./permissions";
import {BuilderVESummary, DeveloperVESummary} from "@/src/components/ve/ve_model";
import {RoundModel} from "@/src/components/project_conf/round_model";

/**
 * Minimal project representation for cards and links.
 */
export interface ProjectMeta {
    project_id: string;
    name: string;
    number: string;
}

export interface ProjectMetaId extends ProjectMeta{
    id: string;
}

export interface Project extends ProjectMeta, Searchables {
    address: Address;
    website?: string;
    deleted?: boolean;
    open_to_companies?: string[];
    invited?: string[];
    expected_start_date?: string;
    expected_duration?: number;
    sub_sector?: string;

    // properties of 'Searchables' - keeping commented here for reference
    // gsf?: number;
    // ROM?: number;
    // sector?: string;
    // market?: string;
    // construction_types?: string[];

    description?: string;
    stage?: string;

    company_id?: string;
    bidding_view?: BiddingView;
    bids: BidBaseModel[];
    root: FolderView;
    company: CompanyBase
}




export interface DeveloperProjectModel extends Project {
    // indexers
    ve_summary: DeveloperVESummary;
    bid_summary: BidSummaryModel[];
}


export interface BuilderProjectModel extends Project {
    // indexers
    bidding_view?: BiddingView;
    ve_summary: BuilderVESummary;
    current_round: RoundModel;
}

//////////////////////////////////////
export interface ModuleConfig {
    enabled: boolean;
}

export interface BiddingConfig extends ModuleConfig {
    bid_view_mode: BidderViewMode;
    bidders_must_be_invited_view: boolean;
    bidders_must_be_invited_bid: boolean;
}

export interface VEConfig extends ModuleConfig {
    enable_sharing?: boolean;
    enable_public?: boolean;
}

export enum Discoverability {
    InviteOnly = "InviteOnly",
    PreviouslyApproved= "PreviouslyApproved",
    FUllyDiscoverable= "Open"

}

export interface DeveloperProjectConfig {
    discoverability?: Discoverability;
    bid: BiddingConfig;
    ve: VEConfig;
}

export interface BuilderProjectConfig {

}


export interface whoAmIResponse {
    /**
     * Initial response from the server.
     * probably should be a composition of 'UserReference' and project list
     * */
    id: string,
    company_type: CompanyType,
    company_name: string,
    company_id: string,
    company_permissions: CompanyPermissions,
    email: string,
    name: string,
    projects: ProjectMeta[],
}
